import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Cutomer_Title_Interface } from 'src/app/Interface/Cutomer_Title_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient) { }


  GetRecord1(Province: String,
    City: String,
    Name: String,
    Code: String,
    Karshenas: String,
    SearchCommentType: Number,
    SubmitPeriodDate: number,
    HasCertificateAddress: number,
    FeildActivity: String,
    StartSearchDate: String,
    EndSearchDate: String,
    JustActive: boolean,
  ): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer?Province=" + Province
      + "&City=" + City
      + "&Name=" + Name
      + "&Code=" + Code
      + "&Karshenas=" + Karshenas
      + "&SearchCommentType=" + SearchCommentType
      + "&FeildActivity=" + FeildActivity
      + "&StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&SubmitPeriodDate=" + SubmitPeriodDate
      + "&HasCertificateAddress=" + HasCertificateAddress
      + "&JustActive=" + JustActive
    ).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetCustomerByComment(Province: String,
    City: String,
    Name: String,
    FeildActivity: String,
  ): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetCustomerByComment?Province=" + Province
      + "&City=" + City
      + "&Name=" + Name
      + "&FeildActivity=" + FeildActivity
    ).pipe(
      map(data => {

        return data as any
      })
    )
  }

  GetSearchCalibration(keySearch: String): Observable<Array<Customer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetSearchCalibration?keySearch=" + keySearch).pipe(
        map(data => {
          return data as Array<Customer_List_Interface>
        })
      )
  }

  GetSearchCertificate(keySearch: String): Observable<Array<Customer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetSearchCertificate?keySearch=" + keySearch).pipe(
        map(data => {
          return data as Array<Customer_List_Interface>
        })
      )
  }

  GetDetailCount(): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetDetailCount").pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetSingle(id: Number): Observable<Customer_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetSingle?id=" + id).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )
  }

  GetSingleUser(id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetSingleUser?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetCustomerComment(id: Number, FromMenuCustomer: Number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetCustomerComment?id=" + id
      + "&FromMenuCustomer=" + FromMenuCustomer).pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }

  GetCustomerCommentCheck(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetCustomerCommentCheck").pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  AddCustomer(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Address: Array<Address_Interface>,
    FeildActivity: Array<number>): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {

      for (let detail of item.Dakhli) {
        item.dakhli_temp = item.dakhli_temp + "," + detail.title
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.Email) {
        item.email_temp = item.email_temp + "," + detail.title
      }

      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        type: Number(item.type),
        majaziMobile: item.majaziMobile + '',
        jaygozinMiblie: item.jaygozinMiblie + '',
        Tel: item.tel_temp,
        Dsc: item.dsc,
        SmsActive: item.smsActive,

        del: false,
      })
    }

    var Local_Address: Array<any> = []
    for (let item of Address) {

      for (let detail of item.tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }


      for (let detail of item.email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_Address.push({
        id: item.id,
        title_id: Number(item.title_id),
        address: item.address,
        codepost: item.codepost,
        sandoghpost: item.sandoghpost,
        pishShomareh: item.pishShomareh,
        certificateAddress: item.certificateAddress,
        certificateAddress_en: item.certificateAddress_en,
        tel_list: item.tel_temp,
        email_list: item.email_temp,
        Dakheli: item.dakheli,
        Fax: item.fax,
        Dsc: item.dsc,
        del: false,
      })
    }

    var body = {
      Token: '',
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
      Address: Local_Address,
      FeildActivity: FeildActivity,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/Add", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  AddComment(Dsc: String, CustomerId: number): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      username: '',
      customer_id: CustomerId,
      dsc: Dsc,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/AddComment", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  EditCustomer(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Address: Array<Address_Interface>,
    FeildActivity: Array<number>): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {

      for (let detail of item.Dakhli) {
        item.dakhli_temp = item.dakhli_temp + "," + detail.title
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.Email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        type: Number(item.type),
        majaziMobile: item.majaziMobile + '',
        jaygozinMiblie: item.jaygozinMiblie + '',
        Tel: item.tel_temp,
        Dsc: item.dsc,
        SmsActive: item.smsActive,
        del: false,
      })
    }


    var Local_Address: Array<any> = []
    for (let item of Address) {


      for (let detail of item.tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_Address.push({
        id: item.id,
        title_id: Number(item.title_id),
        address: item.address,
        codepost: item.codepost,
        sandoghpost: item.sandoghpost,
        pishShomareh: item.pishShomareh,
        certificateAddress: item.certificateAddress,
        certificateAddress_en: item.certificateAddress_en,
        tel_list: item.tel_temp,
        email_list: item.email_temp,
        Dakheli: item.dakheli,
        Fax: item.fax,
        Dsc: item.dsc,
        del: false,
      })
    }


    var body = {
      Token: '',
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
      FeildActivity: FeildActivity,
      Address: Local_Address
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/Edit", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  EditUserCustomer(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Address: Array<Address_Interface>,
    FeildActivity: Array<number>): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {

      for (let detail of item.Dakhli) {
        item.dakhli_temp = item.dakhli_temp + "," + detail.title
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.Email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        type: Number(item.type),
        majaziMobile: item.majaziMobile + '',
        jaygozinMiblie: item.jaygozinMiblie + '',
        Tel: item.tel_temp,
        Dsc: item.dsc,
        del: false,
      })
    }

    var Local_Address: Array<any> = []
    for (let item of Address) {
      Local_Address.push({
        id: item.id,
        title_id: Number(item.title_id),
        address: item.address,
        codepost: item.codepost,
        sandoghpost: item.sandoghpost,
        pishShomareh: item.pishShomareh,
        certificateAddress: item.certificateAddress,
        Tel: item.tel,
        Dakheli: item.dakheli,
        Fax: item.fax,
        Dsc: item.dsc,
        del: false,
      })
    }

    var body = {
      Token: '',
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
      FeildActivity: FeildActivity,
      Address: Local_Address
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/EditUser", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  EditCalibration(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {



      if (item.Dakhli != undefined) {
        for (let detail of item.Dakhli) {
          item.dakhli_temp = item.dakhli_temp + "," + detail.title
        }
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      if (item.Dakhli != undefined) {
        for (let detail of item.Email) {
          item.email_temp = item.email_temp + "," + detail.title
        }
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        Tel: item.tel_temp,
        type: Number(item.type),
        jaygozinMiblie: item.jaygozinMiblie + '',
        majaziMobile: item.majaziMobile + '',
        Dsc: item.dsc,
        del: false,
      })
    }


    var body = {
      Token: '',
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/EditCalibration", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  EditKarshnas(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {



      if (item.Dakhli != undefined) {
        for (let detail of item.Dakhli) {
          item.dakhli_temp = item.dakhli_temp + "," + detail.title
        }
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      if (item.Dakhli != undefined) {
        for (let detail of item.Email) {
          item.email_temp = item.email_temp + "," + detail.title
        }
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        Tel: item.tel_temp,
        type: Number(item.type),
        jaygozinMiblie: item.jaygozinMiblie + '',
        majaziMobile: item.majaziMobile + '',
        Dsc: item.dsc,
        del: false,
      })
    }


    var body = {
      Token: '',
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/EditKarshnas", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }


  DeleteCustomer(id: number): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/Delete?id=" + id ).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  AcrchiveCustomer(id: number): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/Acrchive?id=" + id ).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  SpecialCustomer(id: number): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/special?id=" + id ).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  CommentStatus(id: number, Statuse: number, Priority: number): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/CommentStatus?id=" + id
      + "&Priority=" + Priority
      + "&Statuse=" + Statuse).pipe(
        map(data => {
          return data as Customer_Interface
        })
      )
  }

  CommentEdit(id: number, dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/CommentEdit?id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetLinkKarshnasMasole(id: number, type: number): Observable<Array<string>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetLinkKarshnasMasole?id=" + id
      + "&type=" + type).pipe(
        map(data => {
          return data as Array<string>
        })
      )
  }


  CommentDelete(id: number): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/CommentDelete?id=" + id ).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }


  GetCustomerTitle(id: number): Observable<Array<Cutomer_Title_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetCustomerTitle?id=" + id).pipe(
        map(data => {
          return data as Array<Cutomer_Title_Interface>
        })
      )
  }


  GetKarshnas_Type(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetKarshnas_Type").pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

}
